import { createStyles, makeStyles, Theme } from "@material-ui/core";

const useStylesBase = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: theme.palette.background.default,
    },
    fullHeight: {
      height: "100%",
    },
    fullWidth: {
      width: "100vw",
    },
    centerText: {
      textAlign: "center",
    },
    imageHeader: {
      objectFit: "cover",
      width: "100%",
      height: "110vh",
    },
    image: {
      objectFit: "cover",
      width: "100%",
      height: "50vh",
      borderRadius: 15,
    },
    icon: {
      color: theme.palette.primary.main,
    },
    centerCenter: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    header: {
      backgroundColor: "#f8f8f8",
      height: "20vh",
      paddingTop: 50,
      textAlign: "center",
    },
    content: {
      margin: "50px 0",
      textAlign: "justify",
    },
  })
);

export default useStylesBase;
